import client from "./axios";
import { DashboardStatistics } from "../models/generics";

const dashboardStatisticsUrl = `${window.__env.KRAKEND_URL}/v1/statistics`;

export const Dashboard = {
  getStatistics: (params?: URLSearchParams) => client.get<DashboardStatistics>(dashboardStatisticsUrl, { params }),
}